<div style="min-height: 1.7rem;"
     data-pp-message
     [attr.data-pp-amount]="amount"
     data-pp-style-layout="text"
     data-pp-style-logo-type="primary"
     data-pp-style-logo-position="left">
</div>
